import * as angular from "angular";
import {IController} from "angular";
import {ExpensesService} from "../../services/expenses-service.service";

export class expensesTimelineLogsViewComponent implements IController {
  expenseId: any;

  private timeline;

  constructor(private expensesService: ExpensesService) {
  }

  $onInit() {
    this._getLogsTimeline();
  }

  $onChanges(changes) {
    if (changes.expenseId && !changes.expenseId.isFirstChange()) {
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.expenseId) {
      this.expensesService.getExpenseTimeLine(this.expenseId)
        .then((timeline) => {
          this.timeline = timeline;
        })
    }
  }


}

angular
  .module('bringoz.admin.expenses')
  .component('expensesTimelineLogsView', {
    bindings: {
      expenseId: '<'
    },
    template: require('./expenses-timeline-logs-view.html').default,
    controller: expensesTimelineLogsViewComponent
  });
